/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'
import {
    DataTable, TableContainer, Table, TableHead,
    TableRow, TableHeader, TableBody, TableCell, TableToolbar,
    TableToolbarContent, TableToolbarSearch, TableExpandRow, TableExpandedRow, TableExpandHeader, Pagination, Button
} from 'carbon-components-react';
import { Link } from "react-router-dom";
import qs from 'query-string';
import { NewTab16 } from '@carbon/icons-react';
import { useLocation } from 'react-router';
import moment from 'moment';

import TableToolbarDownload from 'common/TableToolbarDownload';
import * as DashboardConstants from '../Dashboards/DashboardConstants';


const QueueTable = (props) => {
    const defaultFirstRowIndex = 0;
    const defaultCurrentPageSize = 5;
    const [paginatedRows, setPaginatedRows] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [firstRowIndex, setFirstRowIndex] = useState(defaultFirstRowIndex);
    const [filteredRows, setFilteredRows] = useState([]);
    const location = useLocation()

    useEffect(() => {
        if (props?.rows?.length) {
            let rows = props.rows.filter(function (e) {
                return e.status === props.status;
            });
            getPaginatedRow(defaultFirstRowIndex, defaultCurrentPageSize);

            setFilteredRows(rows);
            setTotalItems(rows ? rows?.length : 0);

        }
    }, [props.rows])

    function getPaginatedRow(param, pageSize) {
        let rows = props.rows.filter(function (e) {
            return e.status === props.status;
        });
        let startingIndex = Number.isInteger(param) ? param : firstRowIndex;
        let slicedRows = rows.slice(startingIndex, startingIndex + pageSize);
        setPaginatedRows(slicedRows);
        setFilteredRows(slicedRows);
    }
    function getPaginatedRows(param, pageSize) {
        let startingIndex = Number.isInteger(param) ? param : firstRowIndex;
        let slicedRows = filteredRows.slice(startingIndex, startingIndex + pageSize);
        setPaginatedRows(slicedRows);
    }

    return (
        <>
            {filteredRows?.length ?
                <div>
                    <DataTable size="tall" rows={paginatedRows} headers={props.headers} render={({
                        rows,
                        headers,
                        getHeaderProps,
                        getRowProps,
                        getTableProps,
                        getBatchActionProps,
                        onInputChange }) => (
                        <TableContainer>
                            <TableToolbar>
                                <TableToolbarContent>
                                    <TableToolbarSearch
                                        tabIndex={getBatchActionProps().shouldShowBatchActions ? -1 : 0}
                                        onChange={onInputChange}
                                    />
                                    <TableToolbarDownload iconDescription='Export' rows={paginatedRows} headers={props.headers} title="Alerts" filename="export" label="Download" />
                                </TableToolbarContent>
                            </TableToolbar>
                            <Table {...getTableProps()}>
                                <TableHead>
                                    <TableRow>
                                        {props.isExpandable && <TableExpandHeader />}
                                        {headers.map(header => {
                                            console.log(header, "header123"); return (
                                                header.header && <TableHeader {...getHeaderProps({ header })}>
                                                    {header.hidden === false ? header.header : null}
                                                </TableHeader>
                                            )
                                        })}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row, i) => (
                                        props.isExpandable
                                            ?
                                            <React.Fragment key={row.id}>
                                                <TableExpandRow {...getRowProps({ row })}>

                                                    {row.cells.map(cell => {
                                                        if (cell.info.header === "incidentNumber") {
                                                            let incidentId = cell.value ? cell.value : '';
                                                            let client = (row.cells).find(cell => cell.info.header === "client");
                                                            client = client ? client.value : '';
                                                            let sysId = (row.cells).find(cell => cell.info.header === "incidentSysId");
                                                            sysId = sysId ? sysId.value : '';
                                                            let createdAt = (row.cells).find(cell => cell.info.header === "incidentCreatedAt");
                                                            createdAt = createdAt && createdAt.value !== '-' ? moment(createdAt.value).toISOString() : '';
                                                            let queueName = (row.cells).find(cell => cell.info.header === "queueName");
                                                            queueName = queueName ? queueName.value : '';
                                                            let appHostName = (row.cells).find(cell => cell.info.header === "appHost");
                                                            appHostName = appHostName ? appHostName.value : '';
                                                            // let applicationName = (row.cells).find(cell => cell.info.header === "source provider");
                                                            // applicationName = applicationName ? applicationName.value : '';
                                                            let path = '/IncidentDetails';
                                                            const queryParam = qs.parse(location.search);
                                                            console.log(cell, "header cell");
                                                            const newQueryParam = {
                                                                ...queryParam,
                                                                sysId: sysId,
                                                                alertType: "queueAlert",
                                                                incidentId: incidentId,
                                                                workspace: props.workspace,
                                                                client: client,
                                                                applicationName: "", // source provider
                                                                createdAt: createdAt,
                                                                queueName: queueName,
                                                                isQueue: props.isQueue,
                                                                appHostName : appHostName
                                                            }
                                                            return (
                                                                <TableCell key={cell.id}>
                                                                    <div className="incident-link">
                                                                        <Link className="remove-underline"
                                                                            to={
                                                                                {
                                                                                    pathname: path, search: qs.stringify(newQueryParam)
                                                                                }
                                                                            } target="_blank">
                                                                            <div className="incident-id">{cell.value}</div>
                                                                        </Link>
                                                                    </div>
                                                                </TableCell>
                                                            )
                                                        }
                                                        else if (cell.info.header !== "incidentSysId" && cell.info.header !== "incidentURL" && cell.info.header !== "queueName" && cell.info.header !== "incidentCreatedAt" && cell.info.header !== "client"
                                                            && cell.info.header !== "appHost") {
                                                            return <TableCell key={cell.id}>{cell.value}</TableCell>
                                                        }

                                                    })
                                                    }
                                                </TableExpandRow>
                                                {row.isExpanded && (
                                                    <TableExpandedRow colSpan={headers?.length + 1}>
                                                        <div className="exception-tag carbon-display-Semibold-14">Exception tag</div>
                                                        <div className="carbon-display-Regular-14">
                                                            SAP - Red error message appeared - Vendor 1352 not yet created by purchasing organization CH70
                                                        </div>
                                                    </TableExpandedRow>
                                                )}
                                            </React.Fragment>
                                            :
                                            <TableRow key={"row" + i} {...getRowProps({ row })}>
                                                {row.cells.map((cell, index) => (
                                                    <TableCell key={"cell" + index + i}>
                                                        {cell.value}
                                                    </TableCell>
                                                )
                                                )}
                                            </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>)}
                    />
                    <Pagination
                        totalItems={totalItems}
                        backwardText={DashboardConstants.Previouspage}
                        forwardText={DashboardConstants.NextPage}
                        pageSize={5}
                        pageSizes={[5, 10, 15, 25]}
                        itemsPerPageText={DashboardConstants.Itemspage}
                        onChange={({ page, pageSize }) => {
                            let newFirstRowIndex = pageSize * (page - 1);
                            setFirstRowIndex(newFirstRowIndex)
                            getPaginatedRows(newFirstRowIndex, pageSize);
                        }}
                    />
                </div>
                :
                <div className="message carbon-display-Semibold-14">{DashboardConstants.NoDataAvailable}</div>
            }
        </>
    );
}
export default QueueTable
